import type { CityConfig } from "../city-template/types";

export const wheatonConfig: CityConfig = {
  city: "Wheaton",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "wheaton",
  route: "/cities/wheaton",
  title: "Emergency Passport Wheaton IL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Wheaton, Illinois — as fast as 24 hours. Fast passport renewal for Wheaton College students, DuPage County seat residents, and all western suburban travelers. A+ BBB rated registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Wheaton, IL",
  heroSubtitle: "Wheaton College student with a Holy Land study tour and your passport expired? DuPage County seat resident heading to a conference in London? Historic western suburb with deep academic roots but no passport agency in town. We help Wheaton residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Wheaton, Glen Ellyn, and the western suburbs.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wheaton%20Illinois%20historic%20downtown%20with%20the%20iconic%20DuPage%20County%20Courthouse%20and%20charming%20storefronts%20along%20Front%20Street%2C%20Wheaton%20College%20campus%20with%20Blanchard%20Hall%20limestone%20tower%20and%20manicured%20quadrangles%2C%20tree%20lined%20residential%20streets%20in%20the%20western%20Chicago%20suburbs%2C%20Cantigny%20Park%20with%20beautiful%20gardens%20and%20military%20museum%20in%20the%20distance%2C%20classic%20Midwest%20suburban%20atmosphere%20with%20golden%20hour%20warm%20light%2C%20professional%20landscape%20photography&width=1800&height=700&seq=wheaton-hero-001&orientation=landscape",
  heroImageAlt: "Wheaton Illinois downtown Front Street and Wheaton College campus at golden hour",
  geoPosition: "41.8661;-88.1070",
  geoPlacename: "Wheaton, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
    distance: "Approximately 35 minutes east of Wheaton via I-88 / I-290",
  },
  nearbyCitiesZips: [
    { name: "Wheaton", zips: "60187, 60189" },
    { name: "Glen Ellyn", zips: "60137, 60138" },
    { name: "Carol Stream", zips: "60188" },
    { name: "Winfield", zips: "60190" },
    { name: "West Chicago", zips: "60185" },
    { name: "Warrenville", zips: "60555" },
    { name: "Lisle", zips: "60532" },
    { name: "Naperville", zips: "60540, 60563, 60564, 60565" },
    { name: "Bloomingdale", zips: "60108" },
    { name: "Glendale Heights", zips: "60139" },
    { name: "Lombard", zips: "60148" },
    { name: "Downers Grove", zips: "60515, 60516" },
    { name: "Bartlett", zips: "60103" },
    { name: "Hanover Park", zips: "60133" },
    { name: "Roselle", zips: "60172" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — just 35 minutes away via I-88 but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Wheaton and DuPage County travelers" },
    { icon: "ri-graduation-cap-line", title: "Wheaton College Hub", desc: "Serving Wheaton College students and faculty with study abroad, missions, and international academic travel" },
    { icon: "ri-government-line", title: "County Seat Convenience", desc: "DuPage County seat — serving county government employees, residents, and the entire western suburban region" },
  ],
  internalLinks: [
    { name: "Expedited passport in Naperville", route: "/cities/naperville" },
    { name: "Emergency passport help in Elmhurst", route: "/cities/elmhurst" },
    { name: "Urgent passport services in Downers Grove", route: "/cities/downers-grove" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Wheaton, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (approximately 35 minutes east via I-88 and I-290) — without you making the trip. Wheaton residents can ship from any UPS or FedEx in Wheaton or nearby Glen Ellyn. For DuPage County residents, our courier service saves navigating downtown Chicago and dealing with federal building parking.",
  fpcOfficeDistance: "Serving Wheaton, Glen Ellyn, Carol Stream, Winfield, West Chicago, Warrenville, Lisle, Naperville, Bloomingdale, Glendale Heights, Lombard, Downers Grove, Bartlett, Hanover Park, Roselle, and the entire central DuPage County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Wheaton and the entire central DuPage County region. From the historic Wheaton downtown and DuPage County Courthouse to the Wheaton College campus, from the residential neighborhoods to Cantigny Park and beyond — we serve the entire Wheaton community and surrounding suburbs.",
  nearbyCitiesIntro: "We serve Wheaton and all nearby communities including Glen Ellyn, Carol Stream, Winfield, West Chicago, Warrenville, Lisle, Naperville, Bloomingdale, Glendale Heights, Lombard, Downers Grove, Bartlett, Hanover Park, and Roselle.",
  howItWorksIntro: "Most Wheaton travelers complete everything online and ship documents overnight. No need to drive downtown Chicago — our couriers handle the Chicago Passport Agency trip for you. For DuPage County residents, this saves navigating the Eisenhower Expressway and downtown parking.",
  mistakesIntro: "Wheaton is the DuPage County seat and home to Wheaton College with extensive international programs — yet the nearest passport agency is still a downtown Chicago trip. Here are the most common passport mistakes in Wheaton and the central DuPage County area.",
  testimonialsIntro: "Wheaton travelers — from Wheaton College students heading on missions and study abroad to DuPage County government employees to western suburban families and professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Wheaton, IL? Here are the most common ones we hear from DuPage County travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "1+ hour round trip to downtown Chicago", "Impractical for most suburban travelers"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No downtown Chicago trip required", "Perfect for Wheaton College study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Wheaton travelers with immediate departure needs — as fast as 24 hours. Essential for Wheaton College study abroad deadlines and DuPage County business travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No downtown Chicago trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Wheaton adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Wheaton address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Wheaton residents — including Wheaton College students, new citizens, and DuPage County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Wheaton residents who lost their passport before international travel, study abroad, or missions trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Wheaton and DuPage County area families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Wheaton and DuPage County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Wheaton residents who need land/sea travel to Canada or Mexico — ideal for quick North American trips.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Wheaton residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Wheaton business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Wheaton IL", description: "Urgent passport processing for Wheaton Illinois travelers and Wheaton College students with immediate departure needs." },
    { name: "Expedited Passport Renewal Wheaton IL", description: "Fast passport renewal for Wheaton Illinois residents and DuPage County travelers." },
    { name: "First-Time Passport Wheaton IL", description: "New passport application services for Wheaton Illinois residents." },
    { name: "Child Passport Wheaton IL", description: "Minor passport services for Wheaton Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Rachel B.",
      location: "Wheaton, IL — Wheaton College",
      rating: 5,
      text: "Wheaton College's Holy Land study tour was confirmed and I had 10 days to get my first passport. Fast Passport Center walked me through the DS-11 and I had it in 4 days. The Wheaton post office was so easy. My professor was stunned how fast it came. Every Wheaton student needs to know about this.",
      service: "First-Time Passport",
    },
    {
      name: "Michael H.",
      location: "Wheaton, IL",
      rating: 5,
      text: "DuPage County conference in London — I realized my passport expired 2 weeks before departure. Fast Passport Center renewed it in 3 days. Being the county seat, you'd think there'd be a passport agency nearby, but there isn't. The courier service was absolutely worth it. Saved me hours of driving and parking.",
      service: "Passport Renewal",
    },
    {
      name: "Catherine D.",
      location: "Wheaton, IL",
      rating: 5,
      text: "Family trip to France — needed my daughter's first passport and my renewal. Fast Passport Center handled both simultaneously in 5 days. The Wheaton post office on Liberty was convenient and the clerk was great. DuPage County families, this is the stress-free way to get passports done.",
      service: "New & Renewal Passport",
    },
  ],
  facilities: [
    {
      id: "whe-1",
      name: "Wheaton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "122 N Wheaton Ave",
      city: "Wheaton",
      state: "IL",
      zip: "60187",
      phone: "(630) 668-2815",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Wheaton, near downtown and the DuPage County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Wheaton acceptance facility. Convenient to downtown Wheaton, the DuPage County Courthouse, and Wheaton College. Near Front Street shops and restaurants. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "whe-2",
      name: "Glen Ellyn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "757 Duane St",
      city: "Glen Ellyn",
      state: "IL",
      zip: "60137",
      phone: "(630) 469-2499",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Glen Ellyn, approximately 2 miles east of Wheaton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Wheaton and Glen Ellyn residents. Near College of DuPage and downtown Glen Ellyn. Good alternative with potentially shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "whe-3",
      name: "Carol Stream Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "390 S Schmale Rd",
      city: "Carol Stream",
      state: "IL",
      zip: "60188",
      phone: "(630) 668-7277",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Carol Stream, approximately 4 miles north of Wheaton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Carol Stream and northern Wheaton residents. Near North Avenue commercial corridor. Good alternative for northern DuPage County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "whe-4",
      name: "Winfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "0S101 Winfield Rd",
      city: "Winfield",
      state: "IL",
      zip: "60190",
      phone: "(630) 668-0630",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Winfield, approximately 3 miles west of Wheaton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Winfield and western Wheaton residents. Near Central DuPage Hospital. Smaller facility with generally shorter waits.",
      icon: "ri-mail-line",
    },
    {
      id: "whe-5",
      name: "Lisle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1055 E Ogden Ave",
      city: "Lisle",
      state: "IL",
      zip: "60532",
      phone: "(630) 968-4030",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lisle, approximately 5 miles south of Wheaton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lisle and southern Wheaton residents. Near Benedictine University and Morton Arboretum. Good alternative for southern DuPage County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 min drive to Chicago", fpc: "No — ship from Wheaton" },
    { feature: "Time Commitment", agency: "1+ hour round trip plus parking", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Suburbs", agency: "No — downtown parking is a hassle", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Wheaton College Study & Missions Deadlines",
      description: "Wheaton College students regularly discover expired or missing passports just weeks before study abroad programs, Holy Land tours, and missions trips. The downtown Chicago agency is still a trip away. Our courier service is the fastest practical solution for Wheaton College students.",
    },
    {
      icon: "ri-government-line",
      title: "County Employee International Travel",
      description: "DuPage County government employees sometimes need international travel for conferences, trade missions, or official business — often on short notice. The 35-minute Chicago drive plus parking is a half-day ordeal. Our courier service handles it without leaving the county seat.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Wheaton College students and DuPage County travelers don't know that numerous countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for most European destinations, including the UK and Schengen area countries.",
    },
    {
      icon: "ri-image-line",
      title: "Wheaton College ID vs. Passport Photos",
      description: "Wheaton College student IDs do not meet Department of State passport photo standards. The lighting, background, and sizing requirements are completely different. Always use a dedicated passport photo service — the Wheaton Walgreens on Roosevelt Road does reliable passport photos.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form for Minors",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Wheaton area facilities. For children under 16, it's always DS-11 with both parents present. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Missions Trip Visa Confusion",
      description: "Wheaton College missions trip participants often confuse passport validity requirements with visa requirements. Some countries allow missionary visas only with passports valid for 12+ months beyond the return date. Check visa requirements before booking — start both processes early.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Wheaton or DuPage County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in downtown Wheaton or on Roosevelt Road." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with Wheaton College study abroad, missions travel, and suburban family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — just 35 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wheaton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Wheaton, IL?", a: "Fast Passport Center offers emergency passport processing in Wheaton, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (approximately 35 minutes east via I-88) — without you making the trip. For DuPage County residents, this saves navigating downtown Chicago and dealing with federal building parking." },
    { q: "Does Wheaton have a passport agency?", a: "No — Wheaton does not have a regional passport agency despite being the DuPage County seat. The nearest facility is the Chicago Passport Agency approximately 35 minutes east via I-88 and I-290. Fast Passport Center's courier service is the most practical fast option for Wheaton and central DuPage County residents." },
    { q: "Do you serve Wheaton College students?", a: "Absolutely. Fast Passport Center serves Wheaton College students, faculty, and staff. We understand study abroad programs, Holy Land tours, missions trips, and international academic travel. Our 24–48 hour service is ideal for students who need fast passport processing for last-minute study abroad acceptance." },
    { q: "What airport do Wheaton travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is approximately 25 minutes northeast of Wheaton via I-355/I-290. Chicago Midway (MDW) is approximately 30 minutes southeast via I-355/I-55. Both offer extensive international connections. O'Hare is preferred for most international departures." },
    { q: "Can I get my child's passport expedited in Wheaton?", a: "Yes. Fast Passport Center expedites child passports in Wheaton for minors under 16. Both parents must appear or submit notarized consent. We guide DuPage County families through the entire DS-11 process for minors — especially important for Wheaton Christian school and college prep families with international travel." },
    { q: "Does being the county seat help with passport services?", a: "Unfortunately not. While Wheaton is the DuPage County seat with the county courthouse and government offices, passport acceptance is handled at the federal level through USPS acceptance facilities. The county government does not process passport applications. Our courier service bridges the gap between local acceptance facilities and the Chicago Passport Agency." },
    { q: "Where can I get passport photos in Wheaton?", a: "Walgreens on Roosevelt Road, the UPS Store on Butterfield Road, and CVS on Naperville Road all offer passport photos. The Wheaton Post Office on Wheaton Avenue also provides photo services. Wheaton College's campus store may offer photos for students during peak travel seasons. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in DuPage County?", a: "Honestly — no. The Chicago Passport Agency is 35 minutes away but requires appointments booked weeks in advance for non-emergencies. For urgent international travel from Wheaton and DuPage County, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why Wheaton College students, county employees, and DuPage families rely on us." },
  ],
  photoLocations: [
    { name: "Walgreens — Wheaton", address: "2001 N Main St, Wheaton, IL 60187", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Wheaton", address: "25W111 Geneva Rd, Wheaton, IL 60187", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Wheaton", address: "1400 E Roosevelt Rd, Wheaton, IL 60187", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Wheaton Post Office", address: "122 N Wheaton Ave, Wheaton, IL 60187", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Naperville", address: "931 W 75th St, Naperville, IL 60565", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located in Naperville — closest full-service facility to Wheaton. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Lombard", address: "837 S Westmore-Meyers Rd, Lombard, IL 60148", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Alternative SOS facility serving Lombard and eastern DuPage County. REAL ID processing available. Good alternative for eastern Wheaton area residents.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 25 minutes northeast of Wheaton via I-355/I-290",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Most Wheaton international travelers and Wheaton College study abroad students use ORD for direct international flights. About 25 minutes from downtown Wheaton.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 30 minutes southeast of Wheaton via I-355/I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Secondary Chicago airport with strong domestic connections and some international routes. About 30 minutes from Wheaton. Good for Southwest Airlines travelers and domestic connections.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};